import { render, staticRenderFns } from "./ProcessorTxnSummary.vue?vue&type=template&id=dc8e3d24&scoped=true"
import script from "./ProcessorTxnSummary.vue?vue&type=script&lang=js"
export * from "./ProcessorTxnSummary.vue?vue&type=script&lang=js"
import style0 from "./ProcessorTxnSummary.vue?vue&type=style&index=0&id=dc8e3d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8e3d24",
  null
  
)

export default component.exports